export enum TableFieldOption {
    NONE,
    USE_ALLOWANCE,
    USE_LIMIT,
    PARKING_REQUIRED
}
